/**
 * Model definition for Text
 */
export interface InternText {
  __component: 'intern.text';
  id: string;
  text?: string;
  tooltip?: string;
  variant?: 'body1' | 'body2';
  innerPadding?: 'none' | 'both' | 'horizontal' | 'vertical';
}

export function isInternText(obj: { __component?: string }): obj is InternText {
  return obj.__component === 'intern.text';
}
